var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initialized)?_c('BasePageContainer',{staticClass:"pt-6"},[_c('page-header',{attrs:{"has-back":""}},[_vm._v(" 予定編集 ")]),_c('event-form',{ref:"form",attrs:{"event":_vm.event,"is-edit":""},on:{"submit":_vm.updateEvent}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }